import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { financialPeriodsQueryKey, incomeStatementsQueryKey } from "../../financials";

export function useAdminCreateIncomeStatement(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: Dtos.Admin.IncomeStatement.Create.Request) =>
			post<Dtos.Admin.IncomeStatement.Create.Response>(
				`/v2/admin/surety/accounts/${accountId}/income-statements`,
				data,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		createIncomeStatement: mutation.mutate,
		createISLoading: mutation.isPending,
		createISError: mutation.error,
		resetCreateISError: mutation.reset,
	};
}
